import React from "react";
import { X, Users, ChevronRight } from "lucide-react";
import EmployeeSelectStep from "./EmployeeSelectStep";
import ManageStep from "./ManageStep";

const ManageEmployeeLeavesModal = ({
  /* visibility */
  show, onClose,
  /* step */
  step, onStepChange,
  /* employee select */
  employees, empLoading,
  empSearch, onEmpSearchChange,
  onSelectEmployee,
  /* selected employee */
  selectedEmployee,
  /* manage step props */
  empLeaves, empLeavesLoading,
  deletingLeaveIds, onDeleteLeave,
  newLeaveForm, onLeaveFormChange,
  empQuota, empQuotaLoading,
  createLeaveLoading, onCreateLeave,
  /* misc */
  theme, isRTL, language, t,
}) => {
  if (!show) return null;

  const overlayStyle = {
    position: "fixed", inset: 0,
    background: "rgba(0,0,0,0.6)",
    zIndex: 9998,
    display: "flex", alignItems: "center", justifyContent: "center",
    padding: "16px",
  };

  const panelStyle = {
    background: theme === "dark" ? "#1e2533" : "#ffffff",
    borderRadius: "20px",
    padding: "28px",
    width: "100%",
    maxWidth: "640px",
    maxHeight: "85vh",
    overflowY: "auto",
    boxShadow: "0 24px 64px rgba(0,0,0,0.35)",
    direction: isRTL ? "rtl" : "ltr",
  };

  const goBack = () => {
    onStepChange("select");
    onSelectEmployee(null);
  };

  return (
    <div style={overlayStyle} onClick={onClose}>
      <div style={panelStyle} onClick={(e) => e.stopPropagation()}>

        {/* ── Header ── */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {step === "manage" && (
              <button
                onClick={goBack}
                style={{ background: "none", border: "none", cursor: "pointer", color: theme === "dark" ? "#fff" : "#374151", padding: "4px", borderRadius: "8px", display: "flex", alignItems: "center" }}
              >
                <ChevronRight size={20} style={{ transform: isRTL ? "none" : "rotate(180deg)" }} />
              </button>
            )}
            <Users size={22} color="#2e7cba" />
            <div>
              <div style={{ fontSize: "18px", fontWeight: "700", color: theme === "dark" ? "#fff" : "#1a1a1a" }}>
                {step === "select"
                  ? t.manageEmployeeLeaves
                  : (selectedEmployee?.name || selectedEmployee?.employeeName || "")}
              </div>
              {step === "select" && (
                <div style={{ fontSize: "13px", color: theme === "dark" ? "rgba(255,255,255,0.6)" : "rgba(26,26,26,0.6)" }}>
                  {t.manageEmployeeLeavesDesc}
                </div>
              )}
            </div>
          </div>

          <button
            onClick={onClose}
            style={{ background: "none", border: "none", cursor: "pointer", color: theme === "dark" ? "#fff" : "#1a1a1a", padding: "8px", borderRadius: "8px" }}
          >
            <X size={22} />
          </button>
        </div>

        {/* ── Steps ── */}
        {step === "select" && (
          <EmployeeSelectStep
            theme={theme}
            isRTL={isRTL}
            t={t}
            employees={employees}
            loading={empLoading}
            search={empSearch}
            onSearchChange={onEmpSearchChange}
            onSelectEmployee={onSelectEmployee}
          />
        )}

        {step === "manage" && selectedEmployee && (
          <ManageStep
            theme={theme}
            isRTL={isRTL}
            language={language}
            t={t}
            empLeaves={empLeaves}
            empLeavesLoading={empLeavesLoading}
            deletingLeaveIds={deletingLeaveIds}
            onDeleteLeave={onDeleteLeave}
            newLeaveForm={newLeaveForm}
            onLeaveFormChange={onLeaveFormChange}
            empQuota={empQuota}
            empQuotaLoading={empQuotaLoading}
            createLeaveLoading={createLeaveLoading}
            onCreateLeave={onCreateLeave}
          />
        )}
      </div>
    </div>
  );
};

export default ManageEmployeeLeavesModal;